// extracted by mini-css-extract-plugin
export var addButton = "_e4-0";
export var border = "_e4-8";
export var check = "_e4-h";
export var danger = "_e4-6";
export var dropdownContainer = "_e4-1";
export var editModalBody = "_e4-j";
export var footerContainer = "_e4-i";
export var fullWidth = "_e4-a";
export var hide = "_e4-9";
export var icon = "_e4-3";
export var input = "_e4-7";
export var inputFlex = "_e4-b";
export var inputWrapper = "_e4-c";
export var manualFocus = "_e4-5";
export var optionButton = "_e4-4";
export var pillWrapper = "_e4-e";
export var pointer = "_e4-2";
export var showOverflow = "_e4-f";
export var tagsFlex = "_e4-d";
export var xButton = "_e4-g";